import * as React from "react";
import { useContext } from "react";
import { Combobox } from "@/components/ui";
import { ReviewSourceSystem } from "@/services/bedrock";
import { SOURCE_FILTER_LABELS } from "@/components/reviews/ReviewSourceFilterButtons";
import { PlayerCardSettingsContext } from "../Contexts";

interface SourceOption {
  value: ReviewSourceSystem;
  label: string;
}

const SOURCE_OPTIONS: SourceOption[] = (Object.keys(SOURCE_FILTER_LABELS) as ReviewSourceSystem[]).map(source => ({
  value: source,
  label: SOURCE_FILTER_LABELS[source],
}));

interface ReviewSourcesSelectProps {
  value: ReviewSourceSystem[] | null;
  onChange: (value: ReviewSourceSystem[]) => void;
}

const ReviewSourcesSelect: React.FC<ReviewSourcesSelectProps> = ({ value, onChange }) => {
  const { User } = useContext(PlayerCardSettingsContext);
  const selected = SOURCE_OPTIONS.filter(option => value?.includes(option.value));

  return (
    <Combobox
      items={SOURCE_OPTIONS}
      value={selected}
      onValueChange={(options: SourceOption[] | null) => onChange((options ?? []).map(option => option.value))}
      multiple
      showClear
      maxChips="auto"
      placeholder="All sources"
      className="reviewSourcesSelect w-full min-h-10 bg-white"
      disabled={!User.hasWritePermission}
      isItemEqualToValue={(item: SourceOption, current: SourceOption) => item.value === current.value}
      itemToStringLabel={(item: SourceOption) => item.label}
    />
  );
};
export default ReviewSourcesSelect;
